import React, { useState, useEffect } from "react";
import { crossIcon, faceIcon } from "../../constants/Images";
import { Link, Redirect } from "react-router-dom";
import StripeForm from "./StripeForm";
import { useSelector, useDispatch } from "react-redux";
import { applyCoupon, removeCoupon } from "../../redux/actions/checkoutAction";
import Blinking from "../../Loaders/Blinking";
import { toast } from "react-toastify";

export default function Checkout() {
  const [showApplyCouponForm, setShowApplyCouponForm] = useState(false);
  const [couponValue, setCouponValue] = useState("");
  const [selectedPlanDetails, setSelectedPlanDetails] = useState({});
  const dispatch = useDispatch();
  const {charge_success, isApplyCouponStarted, isCouponApplied, couponDetails, isChargeStarted} = useSelector(state => state.checkoutData)

  const {total_discounted_amount, total_discounted_amount_formatted, coupon} = couponDetails || {};

  const handleShowApplyCouponForm = () =>
    setShowApplyCouponForm(!showApplyCouponForm);

  const getParams = () => {
    const queryString = window.location.search;
    let str = queryString.substring(1);
    let queryarr = str.split("&&");
    let obj = {};
    for (let i = 0; i < queryarr.length; i++) {
      let str = queryarr[i];
      let strS = str.split("=");
      obj[strS[0]] = decodeURI(strS[1]);
    }
    setSelectedPlanDetails(obj);
  };

  const handleCounponChange = (e) => {
    e.persist()
    setCouponValue(e.target.value)
  }
  const handleApplyCoupon = () => {
    if(couponValue === "") {
      toast.warn('Please enter the coupon code')
      return;
    }
     let couponObj = {
      coupon: couponValue,
      plan_id: selectedPlanDetails.plan,
     }
     dispatch(applyCoupon(couponObj))
  }
  const handleRemoveCoupon = () => {
     dispatch(removeCoupon())
  }

  useEffect(() => {
    getParams();
  }, []);

  useEffect(() => {
    if(isCouponApplied) {
      setCouponValue("")
      setShowApplyCouponForm(false)
    }
  }, [isCouponApplied]);
 

  return (
    <>
    {
      charge_success && <Redirect to="/customers" />
    }
    <div className="adminCard">
      <div className="orderDetails">
        <h2 className="rs_h4 mb-4">Order Summary</h2>
        <div className="row no-gutters">
          <div className="pr-5">
            <h3 className="planName mb-1">{selectedPlanDetails.name}</h3>
            <p className="planIncludes mb-0">
              {selectedPlanDetails.subscription}{" "}
              <span className="text-uppercase">{`${selectedPlanDetails.type}ly`}</span>
            </p>
          </div>
          <div className="col">
            <h2 className="rs_h3 mb-0">
              <span style={{ fontWeight: "normal" }}>Total Due:</span> 
              <span className={isCouponApplied ? "lineThroughText": null}>
              USD{" "}
              {
                selectedPlanDetails.type === 'year' ? `${selectedPlanDetails.price*12}` : `${selectedPlanDetails.price}`
              }
               
              </span>
              {isCouponApplied ? `USD ${total_discounted_amount}` : null}
            </h2>
            <div className="clearfix profileArea">
              <form
                action=""
                className="form invitePeopleForm"
                style={{ maxWidth: "400px" }}
              >
                <div className="row gutters-5">
                  {showApplyCouponForm ? (
                    <>
                      <div className="col-6 hide-col mt-2">
                        <div className="form-group mt-0">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Coupon Code"
                            defaultValue={couponValue}
                            onChange={handleCounponChange}
                          />
                        </div>
                      </div>
                      <div className="col  mt-2">
                        <div className="form-group mt-0">
                          <button
                            type="button"
                            className="submit-btn rs_secondary_bg  text-uppercase"
                            onClick={handleApplyCoupon}
                          >
                            Apply {isApplyCouponStarted && <Blinking fontSize={20} />}
                          </button>
                          <span
                            className="invitePeopleHide ml-3 c-pointer"
                            onClick={handleShowApplyCouponForm}
                          >
                            <img src={crossIcon} alt="" />
                          </span>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="col-12">
                      {
                        isCouponApplied ? <>
                         <span>Coupon applied <b>{coupon}</b></span> <span
                            className="invitePeopleHide ml-3 c-pointer"
                            onClick={handleRemoveCoupon}
                          >
                            <img src={crossIcon} alt="" />
                          </span>
                        </> : <>
                        <span>Have a Coupon Code?</span>
                      <button
                        type="button"
                        className="rs_btn rs_md_btn rs_secondary_color_btn text-uppercase"
                        onClick={handleShowApplyCouponForm}
                      >
                        Apply
                      </button></>
                      }
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="paymentProcess">
        <div className="row no-gutters">
          <div className="col-5">
            <StripeForm planId={selectedPlanDetails.plan} coupon={isCouponApplied ? coupon : ""} isChargeStarted={isChargeStarted}  plan_description={`${selectedPlanDetails.name} ${selectedPlanDetails.subscription}`} />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}
